import React from 'react';
import { atom, useAtom } from 'jotai';

import type { PDFGenerationState } from 'components/PDFGenerationToast/PDFGenerationToast';
import PDFGenerationToast from 'components/PDFGenerationToast/PDFGenerationToast';
import { useDownloadAlertPdfs } from 'data/alerts';

export const alertPDFGenerationAtom = atom<PDFGenerationState>({});

interface PDFGenerationToastProps {
  toastId: string | number;
}

const AlertPDFGenerationToast = ({ toastId }: PDFGenerationToastProps) => {
  const downloadPdfs = useDownloadAlertPdfs();

  const [alertPDFGeneration, setAlertPDFGeneration] = useAtom(
    alertPDFGenerationAtom
  );

  return (
    <PDFGenerationToast
      toastId={toastId}
      retryDownloadPdfs={downloadPdfs}
      pdfGenerationState={alertPDFGeneration}
      setPdfGenerationState={setAlertPDFGeneration}
    />
  );
};

export default AlertPDFGenerationToast;
